import { render, staticRenderFns } from "./QuotationQuestions.vue?vue&type=template&id=a8eb6040&scoped=true&"
import script from "./QuotationQuestions.vue?vue&type=script&lang=js&"
export * from "./QuotationQuestions.vue?vue&type=script&lang=js&"
import style0 from "./QuotationQuestions.vue?vue&type=style&index=0&id=a8eb6040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eb6040",
  null
  
)

export default component.exports